import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_default_processing_strategyService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { project_id: number, account_id?: number, order_class_id?: number }): 
  Promise<{ result: { Id?: number, CartonizationStrategyWorkflowId?: string, Description?: string, ProcessingStrategyWorkflowId?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.project_id)) {
      missingRequiredInParams.push('\'project_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_default_processing_strategy/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { project_id: number, account_id?: number, order_class_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CartonizationStrategyWorkflowId?: string, Description?: string, ProcessingStrategyWorkflowId?: string }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.project_id)) {
      missingRequiredInParams.push('\'project_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_default_processing_strategy/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { project_id: number, account_id?: number, order_class_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, CartonizationStrategyWorkflowId?: string, Description?: string, ProcessingStrategyWorkflowId?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.project_id)) {
      missingRequiredInParams.push('\'project_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_default_processing_strategy/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      project_id: number, account_id?: number, order_class_id?: number    }) {
        if(isNil(inParams.project_id)) {
          return true; 
        }
      return false;
    }
}
